import React, { useState } from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Avatar,
    Grid,
    IconButton,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { motion, AnimatePresence } from "framer-motion";
import { linkedinProfileLinks } from "../../constants/External";

const reviews = [
  {
    name: "Anil Shrivastava",
    company: "Hewlett Packard Enterprise",
    title: "Really Changed Career",
    review:
    "My career has completely changed since I enrolled in PaperLive Learning's DevOps and Cloud Training! Under the direction of knowledgeable experts, the seminar provided a thorough examination of important ideas and resources...",
    image: linkedinProfileLinks[0],
    linkedin: "https://www.linkedin.com/in/anil-shrivastava-7768b6334/",
  },
  {
    name: "Dilip Mehta",
    company: "PhonePe",
    title: "Absolutely Game Changer",
    review:
    "The DevOps training I received from PaperLive Learning fundamentally changed the way I think about software development and deployment. The course creates a solid connection between development and operations...",
    image: linkedinProfileLinks[1],
    linkedin: "https://www.linkedin.com/in/dilip-mehta-110615332/",
  },
  // {
  //   name: "Soubhagya Ranjan Sethy",
  //   company: "TCS",
  //   title: "Learned So Much",
  //   review:
  //   "Paperlive Learning’s DevOps training transformed my grasp of software development and deployment. Covering basic to advanced topics, the course effectively bridges development and operations teams...",
  //   image: linkedinProfileLinks[2],
  //   linkedin: "https://www.linkedin.com/in/soubhagya-ranjan-sethy-4120a819b/",
  // },
  {
    name: "Suraj Sharma",
    company: "Concentrix",
    title: "Amazing Learning Experience",
    review:
    "I thoroughly enjoyed this course on DevOps and Cloud! The instructor provided exceptional support at every stage and was quite knowledgeable...",
    image: linkedinProfileLinks[3],
    linkedin: "https://www.linkedin.com/in/suraj-sharma-4b04b7332/",
  },
  {
    name: "Zaid Hassmi",
    company: "Deloitte",
    title: "Highly Recommend This",
    review:
    "I had a great time with this DevOps and Cloud course. The instructor was incredibly knowledgeable and provided excellent support throughout...",
    image: linkedinProfileLinks[4],
    linkedin: "https://www.linkedin.com/in/zaid-hassmi-6627891bb/",
  },
  {
    name: "Sridevi Rao",
    company: "Cognizant",
    title: "Really Appreciate This",
    review:
    "This training was a great learning experience because it was comprehensive and practical. We are really grateful to the instructor for their exceptional help...",
    image: linkedinProfileLinks[5],
    linkedin: "https://www.linkedin.com/in/sridevi-rao-323810331/",
  },
  {
    name: "Syed Shayan Ali",
    company: "SAP",
    title: "Learned Practically Well",
    review:
    "The course was thorough and hands-on, offering a great learning experience. A huge thanks to the instructor for their excellent support...",
    image: linkedinProfileLinks[6],
    linkedin: "https://www.linkedin.com/in/syed-shayan-ali-793152230/",
  },
  {
    name: "Sameer Suman",
    company: "CRED",
    title: "Helped Me Grow",
    review:
    "PaperLive provides great assistance, such as one-on-one mentoring sessions and a variety of code tasks, to help close the knowledge gap...",
    image: linkedinProfileLinks[7],
    linkedin: "https://www.linkedin.com/in/sameer-suman-bb1b33335/",
  },
  {
    name: "Anant Kumar",
    company: "Wipro",
    title: "Great Learning Support",
    review:
    "Paperlive offers exceptional features, including one-on-one mentorship sessions and a variety of coding problems...",
    image: linkedinProfileLinks[8],
    linkedin: "https://www.linkedin.com/in/anant-kumar46/",
  },
  {
    name: "Hamza Imam",
    company: "Wipro",
    title: "Loved The Training",
    review:
    "Outstanding features offered by Paperlive include comprehensive practical sessions, individualised one-on-one mentoring...",
    image: linkedinProfileLinks[9],
    linkedin: "https://www.linkedin.com/in/hamza-imam-4634a9335/",
  },
  {
    name: "Ayush Raj",
    company: "Accenture",
    title: "Helped Me Transition",
    review:
    "Originally from a non-tech background, I found that Paperlive provides outstanding features, such as one-on-one mentorship sessions...",
    image: linkedinProfileLinks[10],
    linkedin: "https://www.linkedin.com/in/ayush-raj-b4663a251/",
  },
  {
    name: "Wasil Hasnain",
    company: "Lowe's India",
    title: "Highly Valuable Training",
    review:
    "Paperlive provides outstanding features, such as full practical sessions, personalized one-on-one mentorship...",
    image: linkedinProfileLinks[11],
    linkedin: "https://www.linkedin.com/in/wasil-hasnain-77a140193/",
  },
  {
    name: "Apurva Raj",
    company: "Capgemini",
    title: "Helped Me Succeed",
    review:
    "Securing a job without adequate experience in AWS and DevOps technologies was challenging. However, after completing the Cloud and Job Ready Programme...",
    image: linkedinProfileLinks[12],
    linkedin: "https://www.linkedin.com/in/apurva-raj-56439b1b0/",
  },
  {
    name: "Farzil Hai",
    company: "Qualcomm",
    title: "Learned Valuable Skills",
    review:
    "It was difficult to find employment without sufficient knowledge of AWS and DevOps technologies. But after finishing Paperlive's Cloud and Job Ready Programme...",
    image: linkedinProfileLinks[13],
    linkedin: "https://www.linkedin.com/in/farzil-hai-40a961324/",
  },
  {
    name: "Waquar Ali Asghar",
    company: "Credit Saison",
    title: "Outstanding Experience Overall",
    review:
    "I had the pleasure of participating in the DevOps and Cloud Training program with Paperlive Learning, and it was an outstanding experience...",
    image: linkedinProfileLinks[14],
    linkedin: "https://www.linkedin.com/in/waquar-ali-asghar-207428190/",
  },
  {
    name: "Akhil Bhatt",
    company: "Oracle",
    title: "Amazing Learning Journey",
    review:
    "It was an amazing experience for me to take part in Paperlive Learning's DevOps and Cloud Training program...",
    image: linkedinProfileLinks[15],
    linkedin: "https://www.linkedin.com/in/akhil-bhatt-a69b13335/",
  },
  {
    name: "Eyon Utkarsh",
    company: "Standard Chartered",
    title: "Truly Career Changing",
    review:
    "Participating in the DevOps and Cloud Training with Paperlive Learning was a game-changer for my career!",
    image: linkedinProfileLinks[16],
    linkedin: "https://www.linkedin.com/in/eyon-utkarsh-02b594175/",
  },
  ];  

export default function ReviewsSection(props) {
    const { isSmallScreen } = props;
    const [startIndex, setStartIndex] = useState(0);
    const visibleCount = isSmallScreen ? 1 : 3;

    const handlePrev = () => {
        setStartIndex((prev) =>
            prev - visibleCount < 0 ? reviews.length - visibleCount : prev - visibleCount
        );
    };

    const handleNext = () => {
        setStartIndex((prev) =>
            prev + visibleCount >= reviews.length ? 0 : prev + visibleCount
        );
    };

    const visibleReviews = reviews.slice(startIndex, startIndex + visibleCount);

    const finalVisible =
        visibleReviews.length < visibleCount
            ? [...visibleReviews, ...reviews.slice(0, visibleCount - visibleReviews.length)]
            : visibleReviews;

    const truncate = (text, limit) =>
        text.length > limit ? text.substring(0, limit) + "..." : text;

    return (
        <Box
            sx={{
                width: { xs: "70%", md: "70%" },
                mx: "auto",
                mt: isSmallScreen ? 6 : 8,
                mb: 4,
                position: "relative",
            }}
        >
            <Typography variant={isSmallScreen ? "h4" : "h3"} fontWeight="bold" gutterBottom>
                Reviews
            </Typography>

            {/* Arrows */}
            <IconButton
                aria-label="Previous Reviews"
                onClick={handlePrev}
                sx={{
                    position: "absolute",
                    left: -60,
                    top: "50%",
                    transform: "translateY(-50%)",
                    backgroundColor: "white",
                    boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                    zIndex: 2,
                }}
            >
                <ArrowBackIosNewIcon />
            </IconButton>

            <IconButton
                aria-label="Next Reviews"
                onClick={handleNext}
                sx={{
                    position: "absolute",
                    right: -60,
                    top: "50%",
                    transform: "translateY(-50%)",
                    backgroundColor: "white",
                    boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                    zIndex: 2,
                }}
            >
                <ArrowForwardIosIcon />
            </IconButton>

            <Box
                sx={{
                    overflow: "hidden",
                    minHeight: 480,
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <AnimatePresence mode="wait">
                    <motion.div
                        key={startIndex}
                        initial={{ opacity: 0, x: 80 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -80 }}
                        transition={{ duration: 0.5 }}
                        style={{ width: "100%" }}
                    >
                        <Grid container spacing={4} justifyContent="center">
                            {finalVisible.map((r, i) => (
                                <Grid item xs={12} md={4} key={i}>
                                    <motion.div
                                        initial={{ opacity: 0, y: 1 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        whileHover={{ y: -6 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                borderRadius: "20px 150px 20px 20px",
                                                textAlign: "left",
                                                position: "relative",
                                                overflow: "visible",
                                                borderColor: "#d1c4e9",
                                                p: isSmallScreen ? 0.5 : 1,
                                                boxShadow: "0px 3px 12px rgba(0,0,0,0.05)",
                                                m: "3rem 10px",
                                                height: "350px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => window.open(r.linkedin, "_blank")}
                                        >
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "-50px",
                                                    left: "80%",
                                                    transform: "translateX(-50%)",
                                                }}
                                            >
                                                <Avatar
                                                    src={r.image}
                                                    alt={r.name}
                                                    sx={{
                                                        width: 120,
                                                        height: 120,
                                                        border: "4px solid white",
                                                    }}
                                                />
                                            </Box>

                                            <CardContent sx={{ mt: 5, px: 3, pb: 4 }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        mb: 1,
                                                    }}
                                                    
                                                >
                                                    <Box>
                                                        <Typography
                                                            variant="subtitle1"
                                                            fontWeight="bold"
                                                            sx={{
                                                                background: "#f5f5f5",
                                                                borderRadius: "10px",
                                                                px: 1.5,
                                                                py: 0.2,
                                                                display: "inline-block",
                                                            }}
                                                        >
                                                            {r.name}
                                                        </Typography>
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            sx={{ fontWeight: 600, mt: 0.5 }}
                                                        >
                                                            {r.company}
                                                        </Typography>
                                                    </Box>
                                                    <img
                                                        loading="lazy"
                                                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/500px-LinkedIn_logo_initials.png"
                                                        width={20}
                                                        alt="LinkedIn"
                                                    />
                                                </Box>

                                                <Typography
                                                    variant="h7"
                                                    fontWeight="bold"
                                                    sx={{ mt: 1, mb: 1 }}
                                                >
                                                    {r.title}!!
                                                </Typography>

                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{ mb: 2 }}
                                                >
                                                    {truncate(r.review, 150)}
                                                </Typography>

                                                <Box>
                                                    {[...Array(5)].map((_, idx) => (
                                                        <StarIcon key={idx} sx={{ color: "#fbc02d" }} />
                                                    ))}
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </motion.div>
                                </Grid>
                            ))}
                        </Grid>
                    </motion.div>
                </AnimatePresence>
            </Box>

            {/* Dots */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 0,
                    flexWrap: "wrap",
                }}
            >
                {Array.from({ length: Math.ceil(reviews.length / visibleCount) }).map((_, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: idx === Math.floor(startIndex / visibleCount) ? "#673ab7" : "#d1c4e9",
                            mx: 0.5,
                            display: Math.abs(idx - Math.floor(startIndex / visibleCount)) <= 2 ? "block" : "none",
                        }}
                    />
                ))}
            </Box>
        </Box>
    );
}
